module.exports = __webpack_public_path__ + "img/g_santé.960c3763.png";